<template>
  <div class="bigBoxText">
    <div class="header-box">
      <div>
        <el-button type="primary" size="small" @click="downloadFile">
          操作手册
        </el-button> 
      </div>
      <div style="display:flex;align-items: center;">
        <div class="user name-icon" v-if="isLogin" @click="centerClick">个人中心
          <el-dropdown v-if="isLogin" class="account-box">
            <img src="@/image/goMy.png" alt="" style="width: 30px; height: 30px;margin-left:10px" />
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="resetLogin">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <img src="@/image/gologin.png" alt="" v-if="!isLogin" style="width: 23px; height: 23px" @click="goLogin" />

        <div class="loginin" v-if="!isLogin" @click="goLogin">登录</div>
        <div class="login-top" type="primary" @click="anewLogin">重新获取登录信息</div>
      </div>
    </div>

    <div class="top-box">
      <div class="top_left">
        <div class="title">{{ detailForm.auctionProjectName }}</div>
        <div class="bigImg">
          <el-carousel height="340px">
            <el-carousel-item v-for="(item, index) in auctionPictureUrl" :key="index" :interval="2000">
              <img :src="item" alt="" mode="aspectFill" class="bigImg" />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="flexDiv">
          <div class="w210">
            <span>保证金：</span>
            <span v-if="detailForm.bondIs == 1">￥{{ (detailForm.bond / 100).toFixed(2) || 0 }}</span>
            <span v-else>--</span>
            <span class="checkPay" v-if="detailForm.bondIs == 1" @click="dialogVisible = true">查看如何支付</span>
          </div>
          <div class="w210">
            <span>加价幅度：</span>
            <span>￥{{ (detailForm.priceIncrease / 100).toFixed(2) || 0 }}</span>
          </div>

        </div>
        <div class="flexDiv">
          <div class="flex1">
            <span>竞价周期：</span>
            <span>{{ cycleTime }}</span>
          </div>

          <div class="w210">
            <span>起拍价：</span>
            <span>￥{{ (detailForm.startingPrice / 100).toFixed(2) || 0 }}</span>
          </div>

        </div>
        <div class="flexDiv">

          <div class="flex1">
            <span>延时周期：</span>
            <span>{{ detailForm.delayPeriod }}分钟</span>
            <el-tooltip class="item" :content="'若拍卖结束前' + detailForm.delayPeriod + '分钟有人出价，结束时间自动往后延' +
              detailForm.delayPeriod + '分钟'
              " placement="top" effect="light">
              <el-button type="text">
                <img src="@/image/time.png" alt="" style="margin-left:5px" />
              </el-button>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top_right-box">
        <div class="flexDiv">
          <div class="flexDiv_left">
            <span>起拍价：</span>
            <span class="boldText">￥{{ (detailForm.startingPrice / 100).toFixed(2) }}</span>
            <span class="boldRemark">{{
              detailForm.fixedPriceType === 0 ? "（限高价）" : "（限低价）"
            }}</span>
          </div>
          <div class="flexDiv_right">
            <span>项目编号：</span>
            <span>{{ detailForm.auctionProjectCode }}</span>

          </div>
        </div>
        <div class="flexDiv">
          <div class="flexDiv_left">
            <span v-if="detailForm.progressStatus == 3" class="redColor">距开始时间：{{ currentTime }}</span>
            <span v-if="detailForm.progressStatus == 4" class="redColor">距结束时间：{{ currentTime }}</span>
            <span
              v-if="detailForm.progressStatus == 5 || detailForm.progressStatus == 6">结束时间：{{ detailForm.finallyAuctionEndTime }}</span>
          </div>
          <div class="flexDiv_right">
            <span>开始时间：</span>
            <span>{{ detailForm.auctionStartTime }}</span>
          </div>
        </div>
        <div class="flexDiv">
          <div class="flexDiv_left">
            <span>标的物数量：</span>
            <span>{{ detailForm.settlementNum }}{{ detailForm.companyName }}</span>
          </div>
          <div class="flexDiv_right">
            <span>当前领先价：</span>
            <span class="redColor boldText">￥
              {{ firstMoney ? (firstMoney / 100).toFixed(2) : "--"
              }}</span>
          </div>
        </div>
        <div class="title mt10">标的物明细</div>
        <div>
          <el-table :data="tableData" style="width: 96%" height="144">
            <el-table-column type="index" label="序号" align="center"></el-table-column>
            <el-table-column prop="auctionMarkName" label="标的物名称" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="auctionMarkNum" label="数量" align="center">
              <template slot-scope="scope">
                {{ scope.row.auctionMarkNum }}
                {{ scope.row.companyName }}
              </template>
            </el-table-column>
          </el-table>
          <el-tooltip class="item" popper-class="custom-tooltip" effect="dark" :content="detailForm.remarks"
            placement="top-start" v-if="detailForm.remarks">
            <div class="remark">备注：{{ detailForm.remarks }}</div>
          </el-tooltip>
          <div v-else class="remark"></div>
        </div>

        <div class="offerDiv" v-if="type === 0">
          <div class="state" :class="[detailForm.progressStatus < 4 ? 'greenBg' : '',
          detailForm.progressStatus == 4 || detailForm.progressStatus == 6 ? 'redBg' : '',
          detailForm.progressStatus == 5 ? 'grayBg' : '']">{{ detailForm.progressStatus | progressStatusfilter }}</div>
          <div class="flexStar mt20">
            <img src="@/image/tishi.png" alt="" style="width:50px;height:50px" />
            <div class="text">
              按照平台规则，为成功参与竞拍，您需要按照下方项目要求填写相关信息，并上传相关资质证明文件，后台审核通过后报名成功。
            </div>
          </div>
        </div>
        <!-- 未登录   -->
        <div class="offerDiv" v-if="type && detailForm.progressStatus <= 4">
          <div class="state" :class="[detailForm.progressStatus < 4 ? 'greenBg' : '',
          detailForm.progressStatus == 4 || detailForm.progressStatus == 6 ? 'redBg' : '',
          detailForm.progressStatus == 5 ? 'grayBg' : '']">{{ detailForm.progressStatus | progressStatusfilter }}</div>
          <div class="flexCenter">
            <div class="label">出价：</div>
            <div>
              <div class="offer">
                <el-button @click="reduceClick"
                  :disabled="detailForm.progressStatus == 4 && isLogin ? false : true">-</el-button>
                <el-input v-model="offerMoney" oninput="value =value.replace(/[^\-\d.]/g, '') .replace(/^\./g, '').replace(/\.{2,}/g,
                    '.').replace(/(\.\d+)\./g, '$1') .replace(/(-)\./g, '$1') .replace(/\-{2,}/g, '-')
                    .replace(/(\d+|\.)-/g, '$1') .replace(/-(0){2,}/g,'$1') .replace(/(-)0+(\d+)/g, '$1$2')
                    .replace(/^0+(\d)/, '$1') .replace(/(\d{8})\d*/, '$1') .replace(/(\.\d{2})\d*/, '$1')"></el-input>
                <el-button @click="addClick"
                  :disabled="detailForm.progressStatus == 4 && isLogin ? false : true">+</el-button>
              </div>
              <div class="buttonLogin red" v-if="!isLogin && detailForm.progressStatus == 3" @click="goApplication">
                （您未登录）立即报名
              </div>
              <div class="buttonLogin gray" v-if="isLogin && detailForm.progressStatus != 4">出价</div>
              <div class="buttonLogin redBg" @click="offerSure" v-if="detailForm.progressStatus == 4">出价</div>
            </div>
            <div class="tips" style="width:272px" v-if="!isLogin && detailForm.progressStatus == 3">
              温馨提示：竞拍开始前，请先在下方填报并提交资料进行报名，资料审核通过后报名成功。如您已报名成功，请先登录。
            </div>
          </div>
        </div>

        <!-- 已登录且项目已结束 -->
        <div class="offerDiv" v-if="type && detailForm.progressStatus == 5">
          <div class="state" :class="[detailForm.progressStatus < 4 ? 'greenBg' : '',
          detailForm.progressStatus == 4 ? 'redBg' : '',
          detailForm.progressStatus == 5 || detailForm.progressStatus == 6 ? 'grayBg' : '']">{{ detailForm.progressStatus |
            progressStatusfilter}}</div>
          <!--项目结束 本人账号没有成为胜出者 -->
          <div class="over-box mt10" v-if="winningBuyer == null">
            <div class="tips"> 恭喜 <span class="person-center redColor">{{ detailForm.winOutAuctionAccount ||
                "--"}}</span>
              成为本次竞拍的胜出者，请在48小时内前往项目中心</div>
            <div class="tips mt10"> 完成后续款项支付及其他事宜</div>
          </div>
          <!--项目结束 本人账号已成为胜拍者 -->
          <div v-if="winningBuyer == 1" class="over-box mt15">
            <div class="tips"> 恭喜您成为本次竞拍的胜出者，请在48小时内前往项目中心</div>
            <div class="tips mt10"> 完成后续款项支付及其他事宜</div>
          </div>
          <!--项目结束 本人账号已出局 -->
          <div class="tips mt25 no-tips" v-if="winningBuyer == 0"> 您参与的本次竞价竞拍失败，请持续关注我们的其他竞拍活动！</div>
        </div>


        <!-- 已登录且项目已结束并且流拍 -->
        <div class="offerDiv" v-if="type && detailForm.progressStatus == 6">
          <div class="state" :class="[detailForm.progressStatus < 4 ? 'greenBg' : '',
          detailForm.progressStatus == 4 ? 'redBg' : '',
          detailForm.progressStatus == 5 || detailForm.progressStatus == 6 ? 'grayBg' : '']">{{ detailForm.progressStatus |
            progressStatusfilter}}</div>
          <div class="tips no-tips mt30"> 无人出价，本场竞价失败！</div>
        </div>
      </div>
    </div>
    <div class="flowPath">
      <img src="@/image/flowPath.png" alt="" />
      <div class="flowPathTitle">竞拍流程：</div>
      <div>买家上传资料</div>
      <img src="@/image/next.png" alt="" class="next" />
      <div>平台审核</div>
      <img src="@/image/next.png" alt="" class="next" />
      <div>审核通过</div>
      <img src="@/image/next.png" alt="" class="next" />
      <div>缴纳保证金</div>
      <img src="@/image/next.png" alt="" class="next" />
      <div>出价竞拍</div>
      <img src="@/image/next.png" alt="" class="next" />
      <div>竞价成功</div>
      <img src="@/image/next.png" alt="" class="next" />
      <div>支付款项</div>
      <img src="@/image/next.png" alt="" class="next" />
      <div>提货</div>
    </div>
    <div class="content" v-if="type">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="竞拍公告" name="first">
          <div v-html="auctionContent.auctionAnnouncement"></div>
        </el-tab-pane>
        <el-tab-pane label="标的物介绍" name="second">
          <div v-html="auctionContent.markIntroduce"></div>
        </el-tab-pane>
        <el-tab-pane label="竞拍须知" name="third">
          <div class="tips-box">{{ auctionContent.biddingNotice }}</div>
        </el-tab-pane>
        <el-tab-pane label="保证金须知" name="fourth">
          <div class="tips-box">{{ auctionContent.bondNotice }}</div>
        </el-tab-pane>
        <el-tab-pane :label="'竞拍记录' + '（' + listLength + '）'" name="five">
          <el-table :data="listData" style="width: 100%" max-height="530px">
            <el-table-column prop="bidStatus" label="状态" align="center">
              <template v-slot="scope">
                <span v-if="scope.row.bidStatus == 1" class="redColor">领先</span>
                <span v-else-if="scope.row.bidStatus == 0">出局</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column prop="auctionAccount" label="竞买用户" align="center"></el-table-column>
            <el-table-column prop="bidMoney" label="价格(元)" align="center">
              <template v-slot="scope">
                <span>{{ (scope.row.bidMoney / 100).toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="出价时间" align="center">
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div v-if="type === 0" class="personalForm">
      <div class="form">
        <el-form :model="formLabelAlign" label-width="140px" size="small" style="overflow: hidden" ref="formLabelAlign"
          :rules="rules">
          <div class="codeIcon">基本信息</div>
          <div class="elFormBox">
            <el-form-item label="买家性质" prop="type">
              <el-select v-model="formLabelAlign.type" style="width: 300px" placeholder="请选择"
                @change="formLabelAlignChange">
                <el-option label="自然人" :value="1"></el-option>
                <el-option label="企业" :value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="买家名称" prop="userName" class="ml100r">
              <el-input v-model="formLabelAlign.userName" style="width: 300px" placeholder="请输入买家名称"></el-input>
            </el-form-item>
          </div>
          <div class="elFormBox">
            <el-form-item :label="formLabelAlign.type == 0 ? '社会信用代码' : '身份证号码'" prop="idCard">
              <el-input v-model="formLabelAlign.idCard" style="width: 300px"
                :placeholder="formLabelAlign.type == 0 ? '请输入社会信用代码' : '请输入身份证号码'"></el-input>
            </el-form-item>
            <el-form-item label="联系人" prop="linkUserName" class="ml100r">
              <el-input v-model="formLabelAlign.linkUserName" style="width: 300px" placeholder="请输入联系人"></el-input>
            </el-form-item>
          </div>
          <div class="elFormBox">
            <el-form-item label="联系电话" prop="linkUserPhone">
              <el-input v-model="formLabelAlign.linkUserPhone" style="width: 300px" placeholder="请输入联系电话"></el-input>
            </el-form-item>
            <div class="idCars ml100r">
              <div style="display: flex; margin-left: 23px;position: relative;">
                <div :class="formLabelAlign.type == 1 ? 'idCarsIcon' : 'idCarsIcon2'">*</div>
                <el-form-item :label="formLabelAlign.type == 1 ? '身份证正反面' : '营业执照'"
                  :label-width="formLabelAlign.type == 1 ? '115px' : '115px'"></el-form-item>
              </div>

              <div style="position: relative" class="upload">
                <el-upload v-if="!carImg" class="upload-demo" action="/hxkj_management_server_api/com/file/fileUpload"
                  :on-change="handleChange" :file-list="fileList" :on-success="successImg" :show-file-list="false">
                  <div class="uploadCar">
                    <div><i class="el-icon-plus"></i></div>
                    <div class="ftcB4 fs14" style="padding: 4px 0" v-if="formLabelAlign.type == 1">
                      请上传身份证人像面照片
                    </div>
                  </div>
                </el-upload>
                <div class="avatar-box" v-if="showcarImg">
                  <img :src="showcarImg" alt="" />
                  <i class="el-icon-close clearVideo" @click="clearVideo"></i>
                </div>
                <el-upload v-if="!carImg1 && formLabelAlign.type == 1" class="upload-demo"
                  action="/hxkj_management_server_api/com/file/fileUpload" :on-change="handleChange"
                  :file-list="fileList1" :on-success="successImg1" :show-file-list="false">
                  <div class="uploadCar">
                    <div><i class="el-icon-plus"></i></div>
                    <div class="ftcB4 fs14" style="padding: 4px 0">
                      请上传身份证国徽面照片
                    </div>
                  </div>
                </el-upload>
                <div class="avatar-box" v-if="showcarImg1">
                  <img :src="showcarImg1" alt="" />
                  <i class="el-icon-close clearVideo" @click="clearVideo1"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="codeIcon">资质信息</div>
          <div class="pl60">
            <el-upload class="upload-demo" drag action="/hxkj_management_server_api/com/file/fileUpload"
              :before-upload="beforeAvatarUpload" :on-success="successaptitudeUrl" :on-remove="clearaptitudeUrl"
              multiple :limit="15" :on-exceed="handleExced" :show-file-list="false">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip mb10" slot="tip">
                只能上传jpg/png/jpeg/pdf/ppt/pptx/doc/docx/xls文件
              </div>
            </el-upload>
            <div v-for="(item, index) in aptitudeUrlList" :key="index">
              <div class="flex-form" @click="deleteClick(index)">
                <div class="mb10 names"><i class="el-icon-document mr10"></i>{{ item.name }}</div>
                <div class="mb10 ml10r pointer redColor" style="font-size:16px">×</div>
              </div>
            </div>
          </div>
        </el-form>
      </div>
      <div class="zizhisubmit">
        <div class="zizhitips">标的物交割时将核实该信息，请保证其真实有效</div>
        <div>
          <el-button class="cancel" @click="cancelAdd">取消</el-button>
          <el-button class="sureBtn" @click="qualificationSubmit">提交</el-button>
        </div>

      </div>
    </div>
    <!-- 验证码弹框 -->
    <bounced :dialogVisible.sync="dialogVisibleCode" title="请输入图形验证码">
      <div slot="slotInfo" class="slotInfo">
        <div class="elFormCode">
          <img :src="baseImg" alt="" class="imgCode" @click="getCodeapi" />
        </div>
        <div>
          <el-form :model="codeForm" ref="codeForm">
            <el-form-item prop="code" :rules="{
              required: true,
              validator: (rule, value, callback) =>
                regular.FormValidateIsTrue(
                  rule,
                  value,
                  callback,
                  regular.verificationCode(value),
                  '请输入长度为4位的验证码'
                ),
            }">
              <el-input v-model="codeForm.code" placeholder="请输入验证码"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="btns">
          <el-button class="cancel" @click="cancelfn">取消</el-button>
          <el-button class="sureBtn" @click="submitcode">确定</el-button>
        </div>
      </div>
    </bounced>
    <!-- 短信验证码 -->
    <bounced :dialogVisible.sync="dialogVisiblesend" title="请输入手机验证码">
      <div slot="slotInfo" class="slotInfo">
        <el-form :model="formLabelAlign" ref="codeForm">
          <el-form-item class="phoneCode" prop="code">
            <el-input v-model="formLabelAlign.code" placeholder="输入手机验证码" style="width: 200px"></el-input>
            <el-button @click="submitcode" :disabled="!isdisable" :class="isdisable ? 'btncode' : 'activeBtn'">{{
              isdisable ? "获取验证码" : `${seconds}后重新获取`
            }}</el-button>
          </el-form-item>
        </el-form>
        <div class="btns">
          <el-button class="cancel" @click="cancelfn">取消</el-button>
          <el-button class="sureBtn" @click="signAuctionUser">确定</el-button>
        </div>
      </div>
    </bounced>
    <el-dialog title="保证金支付" :visible.sync="dialogVisible" width="480px">
      <div class="dialogContent">
        <div class="mb20">资质审核通过后，请将保证金转账至下方账户：</div>
        <div class="pl20">账户名：{{ detailForm.unitName }}</div>
        <div class="pl20">开户行：{{ detailForm.bankOfDeposit }}</div>
        <div class="mb20 pl20">账号：{{ detailForm.account }}</div>
        <div>支付保证金时，请注明项目编号</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">ok</el-button>
      </span>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="submitDialogVisible" width="480px">
      <div class="dialogContent">
        您的报名信息已经提交成功，平台会将您的登录用户名和密码以短信形式发送到您预留的手机上，请留意！您可登录平台查看审核结果及后续操作！
        <span class="ftcff4">
          若未收到短信通知，可点击当前页面上方"重新获取登录信息"按钮获取登录信息。
        </span>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitDialogVisible = false">确认</el-button>
      </span>
    </el-dialog>


    <!-- 重新获取登录信息 -->
    <el-dialog title="重新获取登录信息" :visible.sync="loginDialogVisible" width="550px">
      <div class="">
        <el-form :model="loginForm" ref="loginForm" label-width="100px">
          <el-form-item label="项目编号：">{{ loginForm.auctionProjectCode }}</el-form-item>
          <el-form-item label="手机号：" prop="mobilePhone" :rules="{ required: true, message: '请输入手机号', trigger: 'blur' }">
            <el-input v-model="loginForm.mobilePhone" style="width:230px" placeholder="请输入手机号码"></el-input>
          </el-form-item>

          <el-form-item label="验证码:" prop="verification"
            :rules="{ required: true, message: '请输入验证码', trigger: 'blur' }">
            <div class="elFormImg">
              <el-input v-model="loginForm.verification" placeholder="输入验证码" style="width: 230px"
                @keyup.enter.native="gohomepage"></el-input>
              <img :src="baseImg2" alt="" class="imgBlock" @click="getLoginCode" />
            </div>
          </el-form-item>
        </el-form>
        <div class="ftcff4">温馨提示："重新获取登录信息"仅限用于注册时没有收到运营商短信的用户或忘记登录信息的用户，一旦重新获取登录信息，原有运营商短信账号密码失效！请用本页面账号密码登录!</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="" @click="anewLoginCancel">取 消</el-button>
        <el-button type="primary" class="sureBtn" @click="anewLoginSure">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 短信验证码 -->
    <bounced :dialogVisible.sync="logindialogVisiblesend" title="请输入手机验证码">
      <div slot="slotInfo" class="slotInfo">
        <el-form :model="loginForm" ref="codeForm">
          <el-form-item class="phoneCode" prop="code" :rules="{}">
            <el-input v-model="loginForm.code" placeholder="输入手机验证码" style="width: 200px"></el-input>
            <el-button @click="submitcodeLogin" :disabled="!isdisable" :class="isdisable ? 'btncode' : 'activeBtn'">{{
              isdisable ? "获取验证码" : `${seconds}后重新获取`
            }}</el-button>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button class="cancel" @click="cancelfn1">取消</el-button>
          <el-button class="sureBtn" @click="signAuctionLogin">确定</el-button>
        </span>
      </div>
    </bounced>

    <!-- 重新获取登录信息展示  -->
    <el-dialog title="登录信息" :visible.sync="loginDialogVisibleSure" width="500px">
      <div class="message-tips">请妥善保管记录以下登录信息，切勿告知他人，关闭弹窗后，将无法再次获取！</div>
      <div class="">
        <el-descriptions title="" :column="1">
          <el-descriptions-item label="项目编号">{{ testForm.auctionProjectCode || "--" }}</el-descriptions-item>
          <el-descriptions-item label="账号">{{ testForm.auctionAccount || "--" }}</el-descriptions-item>
          <el-descriptions-item label="密码">{{ testForm.auctionPassword || "--" }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="makeSure">我知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import regular from "@/util/regular";
import bounced from "@/components/bounced.vue";
import { imageEcho } from "@/api/index";
import { v4 as uuidv4 } from "uuid";
import {
  auctionProjectDetailsById,
  signAuctionUser,
  getCode,
  sendVerificationCode,
  getBidRecord,
  auctionBid,
  details,
  loginOut,
  getProgressStatusEndTime,
  getAuctionAccountPasswordCode,
  verificationAuctionAccountCode,
  verifySMSAuctionAccount
} from "@/api/auction/index.js";
import { ride, except } from "@/util/accuracy"

export default {
  components: {
    bounced,
  },
  data() {
    var validateMaterialConsigneePhone = (rule, value, callback) =>
      regular.FormValidateIsTrue(
        rule,
        value,
        callback,
        regular.testPhone(value),
        "请输入正确的手机号"
      );
    var validateidCard = (rule, value, callback) => {
      let sfz = /^(([1-9][0-9]{5}(19|20)[0-9]{2}((0[1-9])|(1[0-2]))([0-2][1-9]|10|20|30|31)[0-9]{3}([0-9]|X|x))|([1-9][0-9]{5}[0-9]{2}((0[1-9])|(1[0-2]))([0-2][1-9]|10|20|30|31)[0-9]{3}))$/;
      if (this.formLabelAlign.type == 1) {
        if (value == "") {
          return callback(new Error('请输入身份证号码'));
        }
        if (!sfz.test(value)) {
          return callback(new Error('请输入正确的身份证号码'));
        } else {
          callback();
        }
      } else if (this.formLabelAlign.type == 0) {
        if (value == "") {
          return callback(new Error('请输入社会信用代码'));
        } else {
          callback();
        }
      }
    }
    return {
      testForm: {},
      baseImg2: "",
      logindialogVisiblesend: false,
      loginDialogVisibleSure: false,
      anew: false,
      loginForm: {
        code: '',
        auctionProjectCode: '',
        mobilePhone: '',
        verification: ''
      },
      loginDialogVisible: false,
      submitDialogVisible: false,
      auctionSessionId: sessionStorage.getItem("auctionSessionId"),
      regular,
      isLogin: false,
      dialogVisible: false,
      dialogVisibleCode: false,
      dialogVisiblesend: false,
      cycle: "",
      tableData: [],
      activeName: "first",
      listData: [],
      listLength: 0,
      fileList1: [],
      fileList2: [],
      fileList: [],
      aptitudeUrlList: [],
      auctionProjectId: "",
      carImg: "",
      showcarImg: "",
      carImg1: "",
      showcarImg1: "",
      detailForm: {
        startingPrice: 0
      },
      codeForm: {
        code: "",
      },
      formLabelAlign: {
        auctionProjectId: "",
        userName: "",
        idCard: "",
        linkUserName: "",
        linkUserPhone: "",
        type: 1,
        imageUrl: "",
        aptitudeUrl: "",
        code: "",
        uuid: "",
      },
      cycleTime: "",
      rules: {
        type: [
          {
            required: true,
            message: "请选择买家性质",
            trigger: "blur,change",
          },
        ],
        code: [
          {
            required: true,
            message: "请输入短信验证码",
            trigger: "blur,change",
          },
        ],
        userName: [
          {
            required: true,
            message: "请输入买家名称",
            trigger: "blur",
          },
        ],
        idCard: [
          {
            required: true,
            trigger: ["blur", 'change'],
            validator: validateidCard,
          },
        ],
        linkUserName: [
          {
            required: true,
            message: "请输入联系人",
            trigger: "blur",
          },
        ],
        linkUserPhone: [
          {
            required: true,
            message: "请输入联系电话",
            trigger: "blur",
          },
          {
            required: true,
            validator: validateMaterialConsigneePhone,
            trigger: "blur",
          },
        ],
      },
      type: 1,
      baseImg: "",
      isdisable: false,
      seconds: 60,
      auctionPictureUrl: [],
      index: 0,
      auctionAccount: "",
      currentTime: "",
      auctionContent: {},
      offerMoney: 0,
      isOffer: null,
      winningBuyer: null,
      marginConfirmationUserName: null,
      firstMoney: 0,
      isSureLogin: 0,
      // ====== 新增：定时器统一管理 ======
      timers: {
        countdownTimer: null,  // 倒计时定时器
        refreshTimer: null     // 刷新定时器
      },
      _isRefreshing: false,    // 防止重复刷新标志
      offerLoading: false,     // 出价防抖
      _isProjectEnded: false,  // 项目是否已结束标志
    };
  },
  filters: {
    progressStatusfilter(val) {
      if (val == 1) {
        return '待审核'
      } else if (val == 2) {
        return '待发布'
      } else if (val == 3) {
        return '即将开始'
      } else if (val == 4) {
        return '进行中'
      } else if (val == 5) {
        return '已结束'
      } else if (val == 6) {
        return '已结束'
      } else if (val == 7) {
        return '审核驳回'
      } else {
        return '--'
      }
    }
  },
  beforeDestroy() {
    this.clearAllTimers();
  },
  mounted() {
    this.getCodeapi();
    this.auctionProjectId = this.$route.query.auctionProjectId;
    this.formLabelAlign.auctionProjectId = this.auctionProjectId;
    this.auctionProjectDetailsById();
  },
  methods: {
    // ====== 定时器管理方法 ======
    // 清理所有定时器
    clearAllTimers() {
      if (this.timers.countdownTimer) {
        clearInterval(this.timers.countdownTimer);
        this.timers.countdownTimer = null;
      }
      if (this.timers.refreshTimer) {
        clearInterval(this.timers.refreshTimer);
        this.timers.refreshTimer = null;
      }
      // 兼容旧代码
      if (this.timer1) {
        clearInterval(this.timer1);
        this.timer1 = null;
      }
      if (this.timer2) {
        clearInterval(this.timer2);
        this.timer2 = null;
      }
    },

    // 清理倒计时定时器
    clearCountdownTimer() {
      if (this.timers.countdownTimer) {
        clearInterval(this.timers.countdownTimer);
        this.timers.countdownTimer = null;
      }
      if (this.timer1) {
        clearInterval(this.timer1);
        this.timer1 = null;
      }
    },

    // 启动刷新定时器（只在项目未结束时启动）
    startRefreshTimer() {
      // 清除旧的刷新定时器
      if (this.timers.refreshTimer) {
        clearInterval(this.timers.refreshTimer);
        this.timers.refreshTimer = null;
      }
      if (this.timer2) {
        clearInterval(this.timer2);
        this.timer2 = null;
      }

      // 如果项目已结束（状态5或6），不启动刷新定时器
      if (this.detailForm.progressStatus === 5 || this.detailForm.progressStatus === 6) {
        this._isProjectEnded = true;
        return;
      }

      this._isProjectEnded = false;

      // 创建新的刷新定时器（20秒刷新一次）
      this.timers.refreshTimer = setInterval(() => {
        // 每次执行前检查项目状态，如果已结束则停止刷新
        if (this.detailForm.progressStatus === 5 || this.detailForm.progressStatus === 6) {
          this._isProjectEnded = true;
          this.clearAllTimers();
          return;
        }
        
        if (!this._isRefreshing) {
          this._isRefreshing = true;
          this.getProgressStatusEndTime(this.auctionProjectId);
          this.getAllgetBidRecord(this.auctionProjectId);
          setTimeout(() => {
            this._isRefreshing = false;
          }, 500);
        }
      }, 20000);
    },

    // ====== 核心方法（修改部分） ======
    
    // 修改：获取进度状态结束时间
    getProgressStatusEndTime(id) {
      // 清除旧的倒计时定时器
      this.clearCountdownTimer();
      
      getProgressStatusEndTime({ auctionProjectId: id }).then(res => {
        if (res.data.code == 1) {
          let data = res.data.data || {};
          this.firstMoney = data.firstMoney;
          
          // 计算出价默认值
          if (data.firstMoney === 0) {
            if (this.detailForm.startingPrice) {
              this.offerMoney = except(this.detailForm.startingPrice, 100);
            }
            this.isOffer = 1;
          } else {
            this.offerMoney = except(data.firstMoney, 100);
            this.isOffer = 2;
          }
          
          // 更新项目状态
          this.detailForm.progressStatus = data.progressStatus;
          
          // 如果项目已结束（状态5或6），清除所有定时器并停止刷新
          if (data.progressStatus === 5 || data.progressStatus === 6) {
            this._isProjectEnded = true;
            this.clearAllTimers();
            this.currentTime = "--";
            // 项目结束，最后一次获取竞拍记录和详情确保数据最新
            this.getAllgetBidRecord(this.auctionProjectId);
            this.personDetails(this.detailForm.auctionProjectCode);
            return;
          }
          
          // 只有项目未结束才启动倒计时
          if (data.progressStatus < 5) {
            let time = data.progressStatus == 3 ? data.auctionStartTime : data.finallyAuctionEndTime;
            this.$nextTick(() => {
              // 再次确保没有重复定时器
              this.clearCountdownTimer();
              // 创建倒计时定时器
              this.timers.countdownTimer = setInterval(() => {
                this.getCurrentTime(time, data.systemTime);
              }, 1000);
            });
          }
        }
      }).catch((error) => {
        console.error('获取进度状态失败:', error);
      });
    },

    // 修改：获取项目详情
    auctionProjectDetailsById() {
      // 清除旧的倒计时
      this.clearCountdownTimer();
      
      auctionProjectDetailsById({ 
        auctionProjectId: this.auctionProjectId 
      }).then((res) => {
        if (res.data.code == 1) {
          this.detailForm = res.data.data || {};
          
          // 判断项目是否已结束
          if (this.detailForm.progressStatus === 5 || this.detailForm.progressStatus === 6) {
            this._isProjectEnded = true;
          } else {
            this._isProjectEnded = false;
          }
          
          // 判断登录状态
          let auctionSessionId = sessionStorage.getItem("auctionSessionId");
          let auctionProjectCode = sessionStorage.getItem("auctionProjectCode");
          if (auctionSessionId && auctionProjectCode === this.detailForm.auctionProjectCode) {
            this.isLogin = true;
            this.auctionAccount = sessionStorage.getItem("auctionAccount");
          } else {
            this.isLogin = false;
          }
          
          this.tableData = this.detailForm.auctionMark || [];
          this.cycleTime = this.getCycleTime(
            this.detailForm.auctionStartTime,
            this.detailForm.auctionEndTime
          );
          
          // 处理图片
          this.auctionPictureUrl = [];
          let auctionPictureUrl = this.detailForm.auctionContent.auctionPictureUrl.split(",");
          auctionPictureUrl.forEach((element) => {
            this.imageEcho(element).then((res) => {
              this.auctionPictureUrl.push(res);
            });
          });
          
          this.auctionContent = this.detailForm.auctionContent || {};
          
          this.personDetails(this.detailForm.auctionProjectCode);
          this.getProgressStatusEndTime(this.auctionProjectId);
          this.getAllgetBidRecord(this.auctionProjectId);
          
          // 只有项目未结束才启动刷新定时器
          if (!this._isProjectEnded) {
            this.startRefreshTimer();
          } else {
            // 项目已结束，确保清除所有定时器
            this.clearAllTimers();
            this.currentTime = "--";
          }
        }
      }).catch((error) => {
        console.error('获取项目详情失败:', error);
      });
    },

    // 修改：倒计时计算
    getCurrentTime(time, systemTime) {
      let date1 = new Date(time);
      let date2 = new Date();
      let diff = date1.getTime() - date2.getTime();
      
      // 如果时间已过，停止倒计时并刷新数据
      if (diff < 0) {
        this.clearCountdownTimer();
        this.currentTime = "--";
        
        // 防止重复刷新导致死循环
        if (!this._isRefreshing) {
          this._isRefreshing = true;
          // 只刷新一次，不循环触发（项目结束后不会再启动定时器）
          this.auctionProjectDetailsById();
          // 3秒后重置标志
          setTimeout(() => {
            this._isRefreshing = false;
          }, 3000);
        }
        return;
      }
      
      // 计算时间差
      let days = Math.floor(diff / (1000 * 60 * 60 * 24));
      diff -= days * 1000 * 60 * 60 * 24;
      let hours = Math.floor(diff / 1000 / 60 / 60);
      diff -= hours * 1000 * 60 * 60;
      let minutes = Math.floor(diff / 1000 / 60);
      diff -= minutes * 1000 * 60;
      let seconds = Math.floor(diff / 1000);
      
      let timeText = days + '天' + hours + "时" + minutes + "分" + seconds + '秒';
      if (timeText && diff > 0) {
        this.currentTime = timeText;
      } else {
        this.currentTime = "--";
      }
    },

    // 修改：查询竞拍记录
    getAllgetBidRecord(id) {
      getBidRecord({ auctionProjectId: id }).then(res => {
        if (res.data.code == 1) {
          this.listLength = res.data.data.count || 0;
          this.listData = res.data.data.list || [];
        }
      });
    },

    // 修改：出价方法（添加防抖）
    offerSure() {
      // 防抖处理
      if (this.offerLoading) {
        return;
      }
      
      // 如果项目已结束，不允许出价
      if (this._isProjectEnded) {
        return this.$message.warning("项目已结束，无法出价！");
      }
      
      this.offerLoading = true;
      
      try {
        if (!this.auctionAccount) {
          this.offerLoading = false;
          return this.$message.warning("您还未登录，请点击右上角登录按钮进行登录！");
        }
        
        // 项目状态为进行中且此项目需要缴纳保证金但是该用户还没有缴纳保证金
        if ((this.detailForm.progressStatus == 4) &&
          (this.detailForm.bondIs == 1 && this.marginConfirmationUserName == null)) {
          const h = this.$createElement;
          this.offerLoading = false;
          return this.$message({
            type: 'error',
            message: h('p', null, [
              h('div', { style: 'color: #F56C6C;font-size: 14px;' }, '平台暂未确认您的项目保证金，不能参与竞拍'),
              h('div', { style: 'color: #F56C6C;font-size: 14px;' }, '如您已打款，项目结束后，平台会自动将您的保证金退回！')
            ]),
            duration: 8000
          });
        }
        
        // 出价校验逻辑
        let money = ride(this.offerMoney, 100);
        if (this.isOffer === 1) {
          if (this.detailForm.fixedPriceType == 0) {
            if (money > this.detailForm.startingPrice) {
              this.offerLoading = false;
              return this.$message.error("您的出价不能高于起拍价！");
            }
            if (money == this.detailForm.startingPrice) {
            } else if ((money != this.detailForm.startingPrice) && (money > this.detailForm.startingPrice - this.detailForm.priceIncrease)) {
              this.offerLoading = false;
              return this.$message.error("您的出价不能低于一个加价幅度！");
            }
          } else {
            if (money < this.detailForm.startingPrice) {
              this.offerLoading = false;
              return this.$message.error("您的出价不能低于起拍价！");
            }
            if (money == this.detailForm.startingPrice) {
            } else if ((money != this.detailForm.startingPrice) && (money < this.detailForm.startingPrice + this.detailForm.priceIncrease)) {
              this.offerLoading = false;
              return this.$message.error("您的出价不能低于一个加价幅度！");
            }
          }
        }
        if (this.isOffer === 2) {
          if (this.detailForm.fixedPriceType == 0) {
            if (money >= this.detailForm.firstMoney) {
              this.offerLoading = false;
              return this.$message.error("您的出价不能高于或等于当前领先价！");
            }
            if (money == this.detailForm.firstMoney) {
            } else if ((money != this.detailForm.firstMoney) && (money > this.detailForm.firstMoney - this.detailForm.priceIncrease)) {
              this.offerLoading = false;
              return this.$message.error("您的出价不能低于一个加价幅度！");
            }
          } else {
            if (money < this.detailForm.firstMoney) {
              this.offerLoading = false;
              return this.$message.error("您的出价不能低于或等于当前领先价！");
            }
            if (money == this.detailForm.firstMoney) {
            } else if ((money != this.detailForm.firstMoney) && (money < this.detailForm.firstMoney + this.detailForm.priceIncrease)) {
              this.offerLoading = false;
              return this.$message.error("您的出价不能低于一个加价幅度！");
            }
          }
        }
        
        let data = {};
        let uuid = uuidv4().replace(/\-/g, "");
        data.identification = uuid;
        data.auctionProjectId = this.auctionProjectId;
        data.bidMoney = ride(this.offerMoney, 100);
        data.projectType = 1;
        
        this.$confirm(`您的本次出价为：${this.offerMoney}元，请确认！`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          auctionBid({ ...data }).then((res) => {
            if (res.data.code == 1) {
              this.$message({
                type: "success",
                message: "出价成功!",
              });
              
              // 出价成功后刷新数据
              this.clearCountdownTimer();
              this.auctionProjectDetailsById();
            }
            this.offerLoading = false;
          }).catch(() => {
            this.offerLoading = false;
          });
        })
        .catch(() => {
          this.offerLoading = false;
        });
      } catch (error) {
        this.offerLoading = false;
        console.error('出价异常:', error);
      }
    },

    // ====== 以下是原有方法（无需修改） ======
    
    getCycleTime(time, time1) {
      let date1 = new Date(time);
      let date2 = new Date(time1);
      let diff = 0;
      diff = date2.getTime() - date1.getTime();
      let days = Math.floor(diff / (1000 * 60 * 60 * 24));
      diff -= days * 1000 * 60 * 60 * 24;
      let hours = Math.floor(diff / 1000 / 60 / 60);
      diff -= hours * 1000 * 60 * 60;
      let minutes = Math.floor(diff / 1000 / 60);
      diff -= minutes * 1000 * 60;
      let seconds = Math.floor(diff / 1000);
      let days1 = days > 0 ? days + '天' : '';
      let hours2 = hours > 0 ? hours + '时' : '';
      let minutes2 = minutes > 0 ? minutes + '分' : '';
      let seconds2 = seconds > 0 ? seconds + '秒' : '';
      let timeText = days1 + hours2 + minutes2 + seconds2;
      return timeText;
    },

    goLogin() {
      this.$router.push({ path: '/home/auctionLogin' });
    },

    goApplication() {
      if (this.type == 1) {
        this.type = 0;
      }
    },

    sendVerificationCodeapi() {
      let uuid = uuidv4();
      this.UUid = uuid;
      this.getcodefn(uuid).then((res) => {
        this.imgCode = res;
      });
      this.dialogVisible = true;
    },

    cancelAdd() {
      this.type = 1;
    },

    submitcode() {
      this.$refs.codeForm.validate((volid) => {
        if (volid) {
          sendVerificationCode({
            mobilePhone: this.formLabelAlign.linkUserPhone,
            verification: this.codeForm.code,
            uuid: this.formLabelAlign.uuid,
          }).then((res) => {
            if (res.data.code == 1) {
              this.$message({
                type: "success",
                message: res.data.data,
              });
              this.dialogVisibleCode = false;
              this.dialogVisiblesend = true;
              this.isdisable = false;
              this.seconds = 60;
              this.countdownfn();
            } else {
              this.getCodeapi();
            }
          }).catch(() => {
            this.getCodeapi();
          });
        }
      });
    },

    countdownfn() {
      let id = setInterval((res) => {
        if (this.seconds >= 1) {
          this.seconds--;
        } else {
          this.isdisable = true;
          clearInterval(id);
        }
      }, 1000);
    },

    getcodefn(uuid) {
      return new Promise((resolve, reject) => {
        getCode({
          uuid,
        }).then((res) => {
          resolve(res.data.data);
        });
      });
    },

    getCodeapi() {
      this.formLabelAlign.uuid = uuidv4();
      let uuid = this.formLabelAlign.uuid;
      this.getcodefn(uuid).then((res) => {
        this.baseImg = res;
      });
    },

    cancelfn() {
      this.codeForm.code = "";
      this.getCodeapi();
      this.dialogVisibleCode = false;
    },

    cancelfn1() {
      this.formLabelAlign.code = "";
      this.logindialogVisiblesend = false;
    },

    signAuctionUser() {
      let data = { ...this.formLabelAlign };
      if (this.carImg && this.carImg1 == "") {
        data.imageUrl = this.carImg;
      }
      if (this.carImg && this.carImg1) {
        data.imageUrl = this.carImg + "," + this.carImg1;
      }
      data.aptitudeUrl = JSON.stringify(this.aptitudeUrlList);
      signAuctionUser(data).then((res) => {
        if (res.data.code == 1) {
          this.dialogVisiblesend = false;
          this.submitDialogVisible = true;
          this.carImg = "";
          this.carImg1 = "";
          this.$refs.formLabelAlign.resetFields();
          this.type = 1;
          this.codeForm.code = "";
          this.formLabelAlign.code = "";
          this.showcarImg = "";
          this.showcarImg1 = "";
          this.aptitudeUrlList = [];
          this.fileList2 = [];
          this.fileList = [];
          this.fileList1 = [];
          this.getCodeapi();
        }
      });
    },

    handleClick(tab, event) {},

    clearVideo() {
      this.carImg = "";
      this.showcarImg = "";
    },

    clearVideo1() {
      this.carImg1 = "";
      this.showcarImg1 = "";
    },

    clearaptitudeUrl(file, fileList) {
      this.aptitudeUrlList = fileList.map((item) => {
        return { name: item.name, url: item.response.data[0].filePath };
      });
    },

    handleChange() {},

    handleChangeaptitudeUrl() {},

    imageEcho(imgPath) {
      return new Promise((resolve, reject) => {
        imageEcho({
          imgPath,
        }).then((res) => {
          resolve(res.data.data.imageCode);
        });
      });
    },

    fileUploadapi(imgPath) {
      imageEcho({
        imgPath,
      }).then((res) => {
        this.showcarImg = res.data.data.imageCode;
      });
    },

    fileUploadapi1(imgPath) {
      imageEcho({
        imgPath,
      }).then((res) => {
        this.showcarImg1 = res.data.data.imageCode;
      });
    },

    successaptitudeUrl(res, file) {
      if (res.code == 1) {
        this.aptitudeUrlList.push({
          name: res.data[0].fileName,
          url: res.data[0].filePath,
        });
      }
    },

    deleteClick(index) {
      this.aptitudeUrlList.splice(index, 1);
    },

    beforeAvatarUpload(file) {
      if (file.name.includes("jpeg") || file.name.includes("jpg") || file.name.includes("png") ||
        file.name.includes("pdf") || file.name.includes("ppt") || file.name.includes("pptx") ||
        file.name.includes("doc") || file.name.includes("docx") || file.name.includes("xls")
      ) {
      } else {
        return this.$message.error('上传资质信息只能是 jpeg，jpg，png，pdf，ppt，pptx，doc，docx，xls 格式!');
      }
    },

    handleExced(files, fileList) {
      this.$message.warning("最多只能上传15个附件");
    },

    successImg(res, file) {
      if (res.code == 1) {
        this.showcarImg = this.fileUploadapi(res.data[0].filePath);
        this.carImg = res.data[0].filePath;
      } else {
        this.$message.error(res.msg);
      }
    },

    successImg1(res, file) {
      if (res.code == 1) {
        this.showcarImg1 = this.fileUploadapi1(res.data[0].filePath);
        this.carImg1 = res.data[0].filePath;
      } else {
        this.$message.error(res.msg);
      }
    },

    qualificationSubmit() {
      if (this.formLabelAlign.type == 1 && (this.showcarImg == "" && this.showcarImg1 == "")) {
        return this.$message.error("请上传身份证正反面");
      }
      if (this.formLabelAlign.type == 0 && (this.showcarImg == "")) {
        return this.$message.error("请上传营业执照");
      }
      this.$refs.formLabelAlign.validate((valid) => {
        if (valid) {
          this.dialogVisibleCode = true;
        }
      });
    },

    formLabelAlignChange(val) {
      this.formLabelAlign.idCard = "";
      if (val == 1) {
        this.showcarImg1 = "";
        this.carImg1 = "";
      } else {
        this.showcarImg = "";
        this.carImg = "";
        this.showcarImg1 = "";
        this.carImg1 = "";
      }
      this.formLabelAlign = { ...this.formLabelAlign };
    },

    addClick() {
      this.offerMoney = ride(this.offerMoney, 100);
      if (this.detailForm.fixedPriceType === 0) {
        if (this.isOffer === 1) {
          if (this.offerMoney >= this.detailForm.startingPrice) {
            this.offerMoney = except(this.offerMoney, 100);
            return this.$message.error("当前项目限价类型为最高限价，只能低于起拍价！");
          }
        } else {
          if (this.offerMoney <= this.detailForm.firstMoney) {
            this.offerMoney = except(this.offerMoney, 100);
            return this.$message.error("当前项目限价类型为最高限价，不能高于当前领先价！");
          }
        }
      }
      let money = this.detailForm.priceIncrease;
      this.offerMoney += money;
      this.offerMoney = except(this.offerMoney, 100);
    },

    reduceClick() {
      this.offerMoney = ride(this.offerMoney, 100);
      if (this.detailForm.fixedPriceType == 1) {
        if (this.isOffer === 1) {
          if (this.offerMoney <= this.detailForm.startingPrice) {
            this.offerMoney = except(this.offerMoney, 100);
            return this.$message.error("当前项目限价类型为最低限价，不能低于起拍价！");
          }
        } else if (this.isOffer === 2) {
          if (this.offerMoney <= this.detailForm.firstMoney) {
            this.offerMoney = except(this.offerMoney, 100);
            return this.$message.error("当前项目限价类型为最低限价，不能低于当前领先价！");
          }
        }
      } else {
      }
      if (this.offerMoney < this.detailForm.priceIncrease) {
        this.offerMoney = except(this.offerMoney, 100);
        return this.$message.error("出价不可以为负数！");
      } else {
        this.offerMoney -= this.detailForm.priceIncrease;
        this.offerMoney = except(this.offerMoney, 100);
      }
    },

    offerFour() {
      return this.$message.warning("您还未登录，请点击右上角登录按钮进行登录！");
    },

    personDetails(auctionProjectCode) {
      details().then(res => {
        if (res.data.code == 1) {
          let data = res.data.data || {};
          this.marginConfirmationUserName = data.marginConfirmationUserName;
          if (data.auctionProjectCode === auctionProjectCode) {
            this.winningBuyer = data.isWinningBuyer;
          } else {
            this.winningBuyer = null;
          }
        }
      });
    },

    resetLogin() {
      loginOut().then(res => {
        if (res.data.code == 1) {
          sessionStorage.clear();
          this.$router.push({ name: "auction" });
        }
      });
    },

    centerClick() {
      this.$router.push({
        name: "auctionMy",
        query: {
          auctionProjectId: this.auctionProjectId
        }
      });
    },

    anewLogin() {
      this.anew = true;
      this.loginForm.auctionProjectCode = this.detailForm.auctionProjectCode;
      this.getLoginCode();
      this.loginDialogVisible = true;
    },

    getLoginCode() {
      let uuid = uuidv4();
      this.UUid = uuid;
      getAuctionAccountPasswordCode({ uuid: this.UUid }).then(res => {
        if (res.data.code == 1) {
          this.baseImg2 = res.data.data || "";
        }
      });
    },

    anewLoginCancel() {
      this.loginForm = {};
      this.UUid = "";
      this.loginDialogVisible = false;
    },

    anewLoginSure() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          let data = {
            ...this.loginForm,
            uuid: this.UUid
          };
          verificationAuctionAccountCode(data).then(res => {
            if (res.data.code == 1) {
              this.seconds = 60;
              this.countdownfn();
              this.logindialogVisiblesend = true;
            } else {
              this.getLoginCode();
            }
          }).catch(() => {
            this.getLoginCode();
          });
        }
      });
    },

    signAuctionLogin() {
      if (this.loginForm.code == "") {
        return this.$message.error("请输入手机验证码！");
      }
      let data = {
        auctionProjectCode: this.loginForm.auctionProjectCode,
        mobilePhone: this.loginForm.mobilePhone,
        code: this.loginForm.code
      };
      verifySMSAuctionAccount(data).then(res => {
        if (res.data.code == 1) {
          this.testForm = res.data.data || {};
          this.loginDialogVisibleSure = true;
          this.loginDialogVisible = false;
          this.logindialogVisiblesend = false;
        }
      });
    },

    submitcodeLogin() {
      let data = {
        ...this.loginForm,
        uuid: this.UUid
      };
      verificationAuctionAccountCode(data).then(res => {
        if (res.data.code == 1) {
          this.seconds = 60;
          this.countdownfn();
        }
      });
    },

    makeSure() {
      this.loginForm.auctionProjectCode = "";
      this.loginForm.mobilePhone = "";
      this.loginForm.verification = "";
      this.loginForm.code = "";
      this.loginDialogVisibleSure = false;
    },

    downloadFile() {
      const link = document.createElement('a');
      link.href = '/static/环循拍卖平台操作指引.pdf';
      link.download = '环循拍卖平台操作指引.pdf';
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>

<style lang="less" scoped>
.bigBoxText {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 30px;

  .activeBtn {
    border: none !important;
    background-color: #e5e5e5 !important;
  }

  .btncode {
    background-color: #14d393 !important;
    border: 1px solid #14d393;
  }

  .footer {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .pl60 {
    padding-left: 60px;
  }

  .idCars {
    display: flex;
    padding-bottom: 40px;
    width: 430px !important;
  }

  .uploadCar {
    border-radius: 5px;
    border: 1px dashed #e5e5e5;
    width: 200px;
    height: 120px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin-right: 10px;
  }

  .el-icon-plus {
    font-size: 40px;
    font-weight: bold;
    color: #e6e6e6;
  }

  .avatar-box {
    position: absolute;
    top: 0;
    position: relative;
    margin-right: 10px;

    img {
      width: 200px;
      height: 120px;
      display: block;
    }
  }

  .clearVideo {
    position: absolute;
    color: red;
    top: 3px;
    right: 2px;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
  }

  .upload {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .elFormCode {
    .imgCode {
      display: block;
      width: 130px;
      height: 40px;
      margin: 0 auto 20px;
    }
  }

  .btns {
    text-align: center;
  }

  .sureBtn {
    width: 90px;
    height: 37px;
    background: #15d393;
    border: none;
    color: #fff;
  }

  .cancel {
    width: 90px;
    height: 37px;
  }

  .idCarsIcon {
    color: #f56c6c;
    padding-top: 7px;
    position: absolute;
    left: 10px;
  }

  .idCarsIcon2 {
    color: #f56c6c;
    padding-top: 7px;
    position: absolute;
    left: 35px;
  }

  .boldText {
    font-weight: bold;
    font-size: 20px;
  }

  .boldRemark {
    font-weight: 700;
    font-size: 14px;
  }

  .personalForm {
    width: 1390px;
    margin: 0 auto;
  }

  .phoneCode {
    /deep/.el-button {
      color: #fff !important;
      width: 130px;
      margin-left: 7px;
    }
  }

  .elFormBox {
    display: flex;
  }

  .codeIcon {
    position: relative;
    padding: 0 10px 0 35px;
    width: 100%;
    margin: 0 0 16px;
  }

  .codeIcon::before {
    content: "";
    left: 3px;
    top: 3px;
    padding: 0px 2px;
    margin: 0 6px 0 0;
    background: #14d393;
    border-radius: 0 5px 5px 0;
  }

  .mb20 {
    margin-bottom: 20px;
  }

  .pl20 {
    padding-left: 20px;
  }

  .header-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    margin-bottom: 18px;

    .user {
      margin-right: 15px;
      color: #3d3d3d;
      font-size: 16px;
      font-weight: bold;
    }

    .login-top {
      margin-left: 10px;
      color: #a8abb2;
      font-size: 14px;
      cursor: pointer;
    }

    .login-top:hover {
      color: #14d393;
    }
  }

  .dialogContent {
    color: #606266;
    font-size: 14px;
  }

  .top-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 25px;
    height: 578px;

    .top_left {
      margin-right: 30px;
      width: 480px;
      height: 578px;

      .title {
        height: 60px;
        line-height: 60px;
        color: #3d3d3d;
        font-size: 20px;
        font-weight: bold;
      }

      .bigImg {
        width: 480px;
        height: 340px;
        background: #fff;
        margin-bottom: 20px;
      }

      .flexDiv {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 20px;
        padding-right: 20px;
        margin-bottom: 20px;
        font-size: 14px;
        color: #3d3d3d;

        .w210 {
          width: 210px;
        }

        .flex1 {
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }

        .checkPay {
          color: #409eff;
          font-size: 12px;
          cursor: pointer;
        }
      }
    }

    .top_right-box {
      width: 690px;
      height: 520px;

      .title {
        color: #3d3d3d;
        font-size: 20px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 25px;
      }

      .remark {
        color: #3d3d3d;
        font-size: 14px;
        margin-bottom: 15px;
        margin-top: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 730px;
      }

      .flexDiv {
        height: 50px;
        width: 100%;
        display: flex;
        align-items: center;

        .flexDiv_left {
          width: 380px;
          color: #3d3d3d;
          font-size: 16px;
        }

        .flexDiv_right {
          color: #3d3d3d;
          font-size: 16px;
        }
      }

      .offerDiv {
        width: 657px;
        height: 170px;
        background: #f5f7fa;
        position: relative;
        padding-top: 47px;
        box-sizing: border-box;
        cursor: pointer;

        .text {
          width: 548px;
          height: 44px;
          font-size: 14px;
          font-weight: normal;
          line-height: 22px;
          color: #3d3d3d;
          margin-left: 40px;
        }

        .state {
          position: absolute;
          right: 0px;
          top: 0px;
          width: 86px;
          height: 34px;
          line-height: 34px;
          border-radius: 0px 10px 0px 10px;
          color: #ffffff;
          text-align: center;
          font-size: 16px;
          cursor: pointer;
        }

        .green {
          background: #4edeae;
        }

        .flexStar {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          cursor: pointer;
          padding-left: 53px;
        }

        .flexCenter {
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;

          .buttonLogin {
            width: 270px;
            height: 49px;
            line-height: 49px;
            color: #ffffff;
            font-size: 16px;
            text-align: center;
            cursor: pointer;
          }

          .gray {
            background: #A8ABB2;
          }

          .red {
            background: #c21f3a;
          }

          .label {
            color: #3d3d3d;
            font-size: 20px;
          }

          .offer {
            width: 270px;
            height: 40px;
            border-radius: 2px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: #f5f7fa;
            border: 1px solid #e4e7ed;
            box-sizing: border-box;
            margin-bottom: 10px;
            cursor: pointer;
          }

          .tips {
            width: 261px;
            height: 99px;
            background: #ffffe5;
            font-size: 14px;
            color: #3d3d3d;
            line-height: 24px;
            padding: 10px;
            margin-left: 35px;
            box-sizing: border-box;
            cursor: pointer;
          }
        }
      }
    }
  }

  .flowPath {
    width: 1200px;
    height: 84px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 25px;
    background: #ffffe5;
    box-sizing: border-box;
    border: 1px solid #ffdea2;
    margin-bottom: 18px;
    font-size: 16px;

    .next {
      margin-left: 20px;
      margin-right: 20px;
    }

    .flowPathTitle {
      margin-left: 15px;
      margin-right: 15px;
    }
  }

  .content {
    width: 100%;
    border: 1px solid #e7e8ea;
    padding: 12px 18px;
    box-sizing: border-box;
    min-height: 400px;
  }
}

.person-center {
  font-size: 20px;
  font-weight: 600;
  text-decoration: underline;
}

.no-tips {
  text-align: center;
  color: #3D3D3D;
  font-weight: bold;
  font-size: 18px;
}

/deep/ .el-carousel__arrow--left {
  top: 220px;
}

/deep/ .el-carousel__arrow--right {
  top: 220px;
}

.flex-form {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.names {
  width: 350px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  color: #606266;
}

.zizhisubmit {
  margin-top: 50px;
  text-align: center;

  .zizhitips {
    font-size: 14px;
    font-weight: normal;
    color: #E0B05D;
    margin-bottom: 30px;
  }
}

.el-tooltip__popper {
  max-width: 40% !important;
}

.account-box {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.tips-box {
  font-size: 16px;
  color: rgb(102, 102, 102);
  font-family: sans-serif;
}

.over-box {
  text-align: center;
}

.name-icon {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.loginin {
  background: #4EDEAE;
  margin-left: 10px;
  padding: 4px 10px;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

.elFormImg {
  display: flex;

  .imgBlock {
    display: block;
    width: 130px;
    height: 40px;
    margin-left: 10px;
    cursor: pointer;
  }
}

.message-tips {
  color: red;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
  margin-top: -30px;
}

.redColor {
  color: #ff0000;
}

.redBg {
  background: #c21f3a !important;
}

.greenBg {
  background: #4edeae !important;
}

.grayBg {
  background: #a8abb2 !important;
}

.mt10 {
  margin-top: 10px;
}

.mt15 {
  margin-top: 15px;
}

.mt20 {
  margin-top: 20px;
}

.mt25 {
  margin-top: 25px;
}

.mt30 {
  margin-top: 30px;
}

.ml100r {
  margin-left: 100px;
}

.ml10r {
  margin-left: 10px;
}

.mr10 {
  margin-right: 10px;
}

.mb10 {
  margin-bottom: 10px;
}

.pointer {
  cursor: pointer;
}

.ftcB4 {
  color: #b4b4b4;
}

.fs14 {
  font-size: 14px;
}

.ftcff4 {
  color: #ff4d4f;
}
</style>


// WEBPACK FOOTER //
// src/views/auction/detail.vue